import styled from 'styled-components';

export const IconContainer = styled.div<{ hoverText: string }>`
  position: relative;

  ::before {
    content: '${(props) => props.hoverText}';
    position: absolute;
    width: 100%;
    font-size: 10px;
    color: white;
    top: -20px;
    text-align: center;
    background: black;
    border-radius: 1.5rem;
    padding: 4px;
    font-family: MuseoSans-100;
    visibility: hidden;
  }

  :hover::before {
    visibility: visible;
  }
`;
